module.exports = __webpack_public_path__ + "img/cube_purple.8d2fe984.svg";